module.exports = __webpack_public_path__ + "static/book-mockup-bg-6f9337763307088f125be6e3a65677c4.jpg";